import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';

import BrandLibraryIcon from '@assets/icons/brandLibraryIcon';
import { Context } from "routes/private/Editor/Context";
import ToolTip from '@components/Tooltip';

const BrandLibraryTool: React.FC<IProps> = (props) => {
  let context = useContext(Context);
  
  const handleClick = () => {  
    const picker = (context.editorStatus.currentPicker==="BrandLibrary")?undefined:"BrandLibrary";
    context.onShowPicker(picker);
  }
  
  return (
    <S.Root>
      <S.IconContainer
        onClick={handleClick}
      >
        <ToolTip
          tip="Brand Library"
          boxStyle={{
            top: `0px`,
            left: `30px`,
            right: `auto`,
            width: `140px`,
            justifyContent: `start`
          }}        
        >
          <BrandLibraryIcon
            fillColor={["BrandLibrary", "ReplaceImage"].includes(context.editorStatus.currentPicker ?? '') ? C.WHITE : undefined}
          />
        </ToolTip>
      </S.IconContainer>
    </S.Root>
  );
}

export default BrandLibraryTool;